import React, { useEffect } from "react"
import { getFormValues, initialize } from "redux-form"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { LoadingIndicator } from "components/LoadingIndicator"
import PageMetaTags from "components/PageMetaTags"
import Form from "containers/Profile/Form"
import { connect } from "react-redux"
import {
  createMetaTag,
  getBusinessUnits,
  getMetaTags,
  getProfile,
  getRoles,
  updateProfile,
  hideChangePasswordModal,
  updateAuthUserData,
  hideChangePasswordFailureModal,
} from "store/actions"
import { withRouter, Link } from "react-router-dom"
import { FORM_NAMES, LOCAL_STORAGE_TAGS } from "constants/index"
import Tags from "./Tags"
import Notes from "./Notes"
import {
  getEventTeaser,
  hidePwdSecurityCheckModal,
  resetEventTeaser,
  updateProfileMetaTags,
} from "../../store/profile/actions"
import ModalComponent from "components/Modals"
import ChangePasswordModal from "./changePasswordModal"
import { getFileBlob } from "utils"
import { SaveButton } from "components/Buttons"
import Events from "./Events"
import AdminInfo from "./AdminInfo"
import PwdSecurityCheckModal from "./pwdSecurityCheckModal"

const PAGE_TITLE = "My Profile"

const Profile = props => {
  const { userId } = props.match.params

  const isOwnProfile =
    !userId ||
    userId == JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))?.id

  const handleSubmitProfileForm = values => {
    let userRoles
    if (values.type > 0) {
      userRoles = values.roles.map(function (item) {
        return item.id
      })
    }

    let body = {
      ...values,
      public: values.public ? 1 : 0,
      vendor_id: props.vendorId,
      id: isOwnProfile
        ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))?.id
        : userId,
      roles: userRoles,
      profile_pic: values?.delete_file
        ? getFileBlob(values?.profile_pic?.editedImage)
        : null,
    }

    props.updateProfile({
      values: body,
      isOwnProfile: isOwnProfile,
      authUser: props.authUser,
    })
  }

  const handleTagSave = values => {
    const tags = values?.tags?.map(tag => ({
      id: tag.value
        ? tag.value
        : props.metaTags?.find(mTag => mTag.tag === tag.label)?.id,
      tag: tag.label,
    }))

    const body = {
      vendor_id: props.vendorId,
      user_id: userId,
      tags: tags,
    }

    props.updateProfileMetaTags(body)
  }

  const handleNoteSave = note => {
    const body = {
      vendor_id: props.vendorId,
      id: userId,
      notes: note,
    }

    props.updateProfile(body)
  }

  useEffect(() => {
    props.getBusinessUnits()
    props.getMetaTags()
    props.getRoles()
    props.getProfile({
      user_id: userId
        ? userId
        : JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))?.id,
    })
    props.getEventTeaser({
      userId: userId
        ? userId
        : JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))?.id,
    })
    return () => {
      props.resetEventTeaser()
    }
  }, [])

  const handleCreateTag = tagLabel => {
    props.createMetaTag({
      values: {
        vendor_id: props.vendorId,
        tag: tagLabel,
        invisible: false,
        business_unit_id: null,
      },
    })
  }

  useEffect(() => {
    if (props?.profile) {
      const profile_initialValues = {
        roles: props.profile?.roles?.map(role => role.id),
        first_name: props.profile?.first_name,
        last_name: props.profile?.last_name,
        email: props.profile?.email,
        phone: props.profile?.phone,
        public: props.profile?.public,
        display_name: props.profile?.display_name,
        display_email: props.profile?.display_email,
        title: props.profile?.title,
        company: props.profile?.company,
        bio: props.profile?.bio,
        interests: props.profile?.interests,
        gender: props.profile?.gender,
        birthday: props.profile?.birthday,
        public: props.profile?.public,
        fb_link: props.profile?.fb_link,
        insta_link: props.profile?.insta_link,
        tw_link: props.profile?.tw_link,
        yt_link: props.profile?.yt_link,
        linkedin_link: props.profile?.linkedin_link,
        pinterest_link: props.profile?.pinterest_link,
        tiktok_link: props.profile?.tiktok_link,
        profile_pic: { editedImage: props.profile?.profile_pic?.file?.url },
        external_id: props.profile?.external_id,
        birthdate: props.profile?.birthdate
          ? new Date(props.profile?.birthdate * 1000)
              .toISOString()
              .split("T")[0]
          : "",
        hire_date: props.profile?.hire_date
          ? new Date(props.profile?.hire_date * 1000)
              .toISOString()
              .split("T")[0]
          : "",
        country: props.profile?.country,
        city: props.profile?.city,
        state: props.profile?.state,
        zip_code: props.profile?.zip_code,
      }
      props.initializeForm(FORM_NAMES.PROFILE, profile_initialValues)
      props.initializeForm(FORM_NAMES.PROFILE_TAGS, {
        tags:
          props?.profile?.tags?.map(tag => ({
            label: tag?.tag,
            value: tag?.id,
          })) || [],
      })
    }
  }, [props.profile])

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags
          title={
            userId && props.profile
              ? `${props.profile.display_name}'s profile`
              : PAGE_TITLE
          }
        />
        <Container fluid>
          <BreadcrumbTitle
            title={
              userId && props.profile
                ? `${props.profile.display_name}'s profile`
                : PAGE_TITLE
            }
            breadcrumbItems={[{ title: "Dashboard" }, { title: "Profile" }]}
          />
          <Row>
            {props.loading ? (
              <Col xs={12}>
                <LoadingIndicator />
              </Col>
            ) : (
              <>
                <Col xl="4">
                  <Card>
                    <CardBody>
                      <Form
                        onSubmit={handleSubmitProfileForm}
                        saveLoading={props.saveLoading}
                        userType={props.profile?.type}
                        businessUnits={props.businessUnits}
                        roles={props.roles}
                        isOwnProfile={isOwnProfile}
                        userId={
                          userId ||
                          JSON.parse(
                            localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER)
                          )?.id
                        }
                      />
                    </CardBody>
                  </Card>
                </Col>
                {!isOwnProfile && (
                  <Col xl={8}>
                    <Row>
                      <Col xl="6">
                        <Card>
                          <CardBody>
                            <AdminInfo
                              businessUnits={props?.businessUnits}
                              roles={props?.roles}
                              profile={props?.profile}
                            />
                          </CardBody>
                        </Card>
                      </Col>
                      <Col xl="6">
                        <Card>
                          <CardBody>
                            <Tags
                              metaTags={props.metaTags}
                              onTagCreate={handleCreateTag}
                              onSubmit={handleTagSave}
                              saveLoading={props.saveLoading}
                            />
                          </CardBody>
                        </Card>
                      </Col>
                      <Col xl="6">
                        <Card>
                          <CardBody>
                            <Notes
                              handleNoteSave={handleNoteSave}
                              note={props.profile?.notes}
                              saveLoading={props.saveLoading}
                            />
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    {props.eventTeaser?.length > 0 &&
                      props?.location?.state?.displayExp && (
                        <Row>
                          <Col xl="6">
                            <Card>
                              <CardBody>
                                <Events
                                  userId={
                                    isOwnProfile
                                      ? JSON.parse(
                                          localStorage.getItem(
                                            LOCAL_STORAGE_TAGS.AUTH_USER
                                          )
                                        )?.id
                                      : userId
                                  }
                                />
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      )}
                  </Col>
                )}
              </>
            )}
          </Row>
        </Container>
      </div>
      <ModalComponent
        open={props.pwdSecurityCheckModalIsOpen}
        title="Change Password"
        onClose={props.hidePwdSecurityCheckModal}
      >
        <PwdSecurityCheckModal />
      </ModalComponent>
      <ModalComponent
        open={props.changePasswordModalIsOpen}
        title="Change Password"
        onClose={props.hideChangePasswordModal}
      >
        <ChangePasswordModal
          closeHandler={props.hideChangePasswordModal}
          userId={
            isOwnProfile
              ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))
                  ?.id
              : userId
          }
          isOwnProfile={isOwnProfile}
        />
      </ModalComponent>
      <ModalComponent
        open={props.changePasswordFailureModalIsOpen}
        title="Oops..."
        onClose={props.hideChangePasswordFailureModal}
      >
        <Row>
          <Col>
            <h5>Incorrect password!</h5>
          </Col>
        </Row>
        <Row className="d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="OK"
              onClick={props.hideChangePasswordFailureModal}
            />
          </Col>
        </Row>
      </ModalComponent>
    </React.Fragment>
  )
}

let profileFormValues = getFormValues(FORM_NAMES.PROFILE)
const mapStateToProps = state => {
  return {
    profile: state.Profile.profile,
    loading: state.Profile.loading,
    saveLoading: state.Profile.saveLoading,
    profileFormValues: profileFormValues(state),
    businessUnits: state.businessUnits.businessUnits,
    metaTags: state.Tags.metaTags,
    roles: state.Profile.roles,
    vendorId: state.Login.vendorId,
    changePasswordModalIsOpen: state.Profile.changePasswordModalIsOpen,
    authUser: state.Login.authUser,
    changePasswordFailureModalIsOpen:
      state.Profile.changePasswordFailureModalIsOpen,
    eventTeaser: state.Profile.eventTeaser,
    pwdSecurityCheckModalIsOpen: state.Profile.pwdSecurityCheckModalIsOpen,
  }
}

const mapDispatchToProps = dispatch => ({
  getProfile: values => dispatch(getProfile(values)),
  updateProfile: values => dispatch(updateProfile(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
  createMetaTag: values => dispatch(createMetaTag(values)),
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  getRoles: () => dispatch(getRoles()),
  updateProfileMetaTags: values => dispatch(updateProfileMetaTags(values)),
  hideChangePasswordModal: () => dispatch(hideChangePasswordModal()),
  updateAuthUserData: values => dispatch(updateAuthUserData(values)),
  hideChangePasswordFailureModal: () =>
    dispatch(hideChangePasswordFailureModal()),
  getEventTeaser: values => dispatch(getEventTeaser(values)),
  resetEventTeaser: () => dispatch(resetEventTeaser()),
  initializeForm: (form, values) => dispatch(initialize(form, values)),
  hidePwdSecurityCheckModal: () => dispatch(hidePwdSecurityCheckModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile))
